import React, { useContext } from 'react';
import { Row, Col } from "react-bootstrap";
import { LocalizationContext } from '../../../context/LangChange';

const translations = {
    en: require('../../../Translate/en.json').DigitalMarketing,
    ar: require('../../../Translate/ar.json').DigitalMarketing,
};

const SocialMediaSection = () => {
    const { isLang } = useContext(LocalizationContext);
    const t = translations[isLang || 'en'];

    return (
        <div className="social-media-section pb-5">
            <Row    >
                {/* ✅ التسويق عبر وسائل التواصل الاجتماعي */}
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="card">
                        <h2>{t.Marketing.title}</h2>
                        <p>{t.Marketing.subtitle}</p>
                        <ul>
                            {Object.keys(t.Marketing.services).map((key, index) => (
                                <li key={index}>
                                    <strong>{t.Marketing.services[key].title}:</strong> {t.Marketing.services[key].description}
                                </li>
                            ))} 
                        </ul>
                    </div>
                </Col>

                {/* ✅ الإعلانات عبر وسائل التواصل الاجتماعي */}
                <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="card">
                        <h2>{t.Advertising.title}</h2>
                        <p>{t.Advertising.subtitle}</p>
                        <ul>
                            {Object.keys(t.Advertising.services).map((key, index) => (
                                <li key={index}>
                                    <strong>{t.Advertising.services[key].title}:</strong> {t.Advertising.services[key].description}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Col>

                {/* ✅ توليد العملاء المحتملين */}
                {["LeadGeneration", "CRO", "LinkBuilding"].map((section, index) => (
                    <Col xl={4} lg={4} md={12} sm={12} xs={12} key={index}>
                        <div className="card mt-4">
                            <h3>{t[section].title}</h3>
                            <p>{t[section].description}</p>
                            <ul>
                                {[1, 2, 3].map((num) => (
                                    t[section][`title${num}`] ? (
                                        <li key={num}>
                                            <strong>{t[section][`title${num}`]}:</strong> {t[section][`description${num}`]}
                                        </li>
                                    ) : null
                                ))}
                            </ul>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SocialMediaSection;
